import { yup } from '@/libs/yup.ts';

export const schema = yup.object({
  attachments: yup.array(yup.mixed<File>().fileSize().required().label('添付書類')).required()
});

export type Schema = yup.InferType<typeof schema>;
